<template>
<b-col sm="2" class="text-center">
  <b-card
    @click="select(item)" :style="{ cursor: 'pointer'}" no-body style="max-width: 20rem;" img-alt="site screenshot" img-top >
  <template v-slot:header>
    <small>
      <a v-if="item.site && item.site.config && item.site.config.seeds" :href="item.site.config.seeds[0]" class="card-link">{{item.site.fqdn}}</a>
      <span v-else>{{item.site.fqdn}}</span>
  </small>
  </template>
    <b-card-body>
      <b-card-img v-if="item.thumbnail" :src="image(item.thumbnail)" alt="Image" bottom></b-card-img>
      <b-card-text v-else> no screenshot </b-card-text>
    </b-card-body>

    <b-list-group flush>
      <b-list-group-item>
        <span v-if="item.finished_at">{{item.finished_at | sdate}}</span>
        <span v-else>Ready</span>
      </b-list-group-item>
    </b-list-group>

    <b-card-footer v-if="item.site && item.site.config && item.site.config.seeds">
      <b-badge v-if="item.detect_count > 0" variant="danger">Danger : {{item.detect_count}}</b-badge>
      <b-badge v-else variant="success">Good</b-badge>
    </b-card-footer>
  </b-card>
  </b-col>
</template>

<script>

export default {
  components: { },
  data: () => {
    return {
      start : true,
    }
  },
  props: ['item', 'index'],
  methods: {
    select(i) { this.$emit("click", i); },
    image(img) { return img && 'data:image/png;base64,' + img || ''; },
    // detail(item){ this.$router.push(`result/${item.id}`); },
  },
  destroyed () { console.log('Site_Result.vue destroyed') },
  mounted () { console.log('Site_Result.vue mounted') },
}
</script>
